export enum QUERY_KEYS {
  addAdmissionFloorplan = 'add-admission-floorplan',
  addAdmissionsFloorplanArea = 'add-admission-floorplan-area',
  createFloorplan = 'create-floorplan',
  createFloorplanFromPreset = 'create-floorplan-from-preset',
  createFloorplanArea = 'create-floorplan-area',
  createFloorplanAreaImage = 'create-floorplan-area-image',
  createFloorplanImage = 'create-floorplan-image',
  createFloorplanMenu = 'create-floorplan-menu',
  deleteFloorplan = 'delete-floorplan',
  deleteFloorplanApply = 'delete-floorplan-apply',
  deleteFloorplanArea = 'delete-floorplan-area',
  deleteFloorplanPreview = 'delete-floorplan-preview',
  removeSeatingItemFromGroupApply = 'remove-seating-item-from-group-apply',
  editFloorplan = 'edit-floorplan',
  editFloorplanArea = 'edit-floorplan-area',
  getFloorplan = 'floorplan-by-id',
  getFloorplanAdmissions = 'get-floorplan-admissions',
  getFloorplanAreaAdmissions = 'get-floorplan-area-admissions',
  getFloorplanSchema = 'get-floorplan-schema',
  getFloorplanOutline = 'get-floorplan-outline',
  getAreaOutline = 'get-area-outline',
  replaceFloorplanOutline = 'replace-floorplan-outline',
  replaceAreaOutline = 'replace-area-outline',
  getFloorplanViewportSnapshot = 'get-floorplan-viewport-snapshot',
  publishFloorplan = 'publish-floorplan',
  saveFloorplanSchema = 'save-floorplan-schema',
  saveFloorplanViewportSnapshot = 'save-floorplan-viewport-snapshot',
  assignOfferSeatingGroupPreview = 'assign-offer-seating-group-preview',
  assignOfferSeatingGroupApply = 'assign-offer-seating-group-apply',
  assignOfferSeatingItemPreview = 'assign-offer-seating-item-preview',
  assignOfferSeatingItemApply = 'assign-offer-seating-item-apply',
  assignOfferPresetSeatingItemPreview = 'assign-offer-preset-seating-item-preview',
  assignOfferPresetSeatingItemApply = 'assign-offer-preset-seating-item-apply',
  assignOfferPresetSeatingGroupPreview = 'assign-offer-preset-seating-group-preview',
  assignOfferPresetSeatingGroupApply = 'assign-offer-preset-seating-group-apply',
  unassignOfferSeatingGroupPreview = 'unassign-offer-seating-group-preview',
  unassignOfferSeatingGroupApply = 'unassign-offer-seating-group-apply',
  unassignOfferSeatingItemPreview = 'unassign-offer-seating-item-preview',
  unassignOfferSeatingItemApply = 'unassign-offer-seating-item-apply',
  unassignOfferPresetSeatingGroupPreview = 'unassign-offer-preset-seating-group-preview',
  unassignOfferPresetSeatingGroupApply = 'unassign-offer-preset-seating-group-apply',
  unassignOfferPresetSeatingItemPreview = 'unassign-offer-preset-seating-item-preview',
  unassignOfferPresetSeatingItemApply = 'unassign-offer-preset-seating-item-apply',
  editorLockStatus = 'editor-lock-status',
  acquireEditorLock = 'acquire-editor-lock',
  releaseEditorLock = 'release-editor-lock',
}
